import * as actions from './actions';
import * as mutations from './mutations';
import state from './state';

const responsabilidadCivil = {
   namespaced: true,
   actions,
   mutations,
   state,
};
export default responsabilidadCivil;
